export enum CgpApplications {
    DEV = '6607501A-14BF-46A6-8991-A8147F03AF08',
    TEST = '99E6C4EE-077A-4FFD-BFA0-13AAD1E78B23',
    QA = 'B28DD2EE-3BCA-4389-81AA-D414E75C325A',
    PROD = 'D0BB391B-7CE1-40C6-B5DC-1EEAE53F952A'
}

// What pre-prod env should be used when running locally
export const LOCAL_MAP = 'TEST';